import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function IliskiStresiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['iliski-stresi-testi']} />;
}
